import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ConsumerLoanTargetPath } from '../../domain/types';
import { getPath } from '../../helpers/url';
import { useAppDispatch } from '../../hooks';
import useArnFromPath from '../../hooks/useArnFromPath';
import useSettings from '../../hooks/useSettings';
import { invalidateStore } from '../../store/store';
import { setCurrentPage } from '../../store/wizard/wizard';

const InitCoApplicantPage = () => {
    const dispatch = useAppDispatch();
    const settings = useSettings();
    const navigate = useNavigate();

    const applicationReferenceNumber = useArnFromPath();

    useEffect(() => {
        const init = async () => {
            // Must complete before navigating: a stale, still-valid access token from a previous applicant's
            // session (e.g. the main applicant, in the same browser session) would otherwise be briefly
            // readable by CoApplicantLogInPage and misclassified as the co-applicant's own BankID callback.
            await invalidateStore(dispatch);
            dispatch(setCurrentPage(0));

            navigate(
                getPath(
                    ConsumerLoanTargetPath.coapplicant,
                    settings.languageCode,
                    settings.countryCode,
                    applicationReferenceNumber,
                ),
            );
        };
        init();
    }, [dispatch]);

    return (
        <Box display="flex" justifyContent="center" marginBottom={2} marginTop={2}>
            <CircularProgress />
        </Box>
    );
};

export default InitCoApplicantPage;
